var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3245192,13 C15.7876603,13 16.1826923,12.8378244 16.5096154,12.5134731 C16.8365385,12.1891218 17,11.8063872 17,11.3652695 L17,11.3652695 L17,1.63473054 C17,1.19361277 16.8365385,0.810878244 16.5096154,0.486526946 C16.1826923,0.162175649 15.7876603,0 15.3245192,0 L15.3245192,0 L1.67548077,0 C1.21233974,0 0.817307692,0.162175649 0.490384615,0.486526946 C0.163461538,0.810878244 0,1.19361277 0,1.63473054 L0,1.63473054 L0,11.3652695 C0,11.8063872 0.163461538,12.1891218 0.490384615,12.5134731 C0.817307692,12.8378244 1.21233974,13 1.67548077,13 L1.67548077,13 L15.3245192,13 Z M8.5,7.29790419 L1.67548077,3.26946108 L1.67548077,1.63473054 L8.5,5.70209581 L15.3245192,1.63473054 L15.3245192,3.26946108 L8.5,7.29790419 Z",
    id: "mail",
    fill: "#0F0F0F",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.b51257393e3d81bff0d08e1c6e6a8e7e.svg";
export { ForwardRef as ReactComponent };